<template>
  <div class="add-complaints">
    <v-card class="py-4 px-4">
      <v-card-title class="text-center text-h4 font-weight-bold pb-5" style="color: #62608b">Add Complaints and Grievances</v-card-title>
      <v-row align="center" justify="start" class="mx-1">
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="Title"
            class="rounded"
            v-model.trim="$v.title.$model"
            autofocus
            outlined
            dense
          >
          </v-text-field>
          <span v-if="!$v.title.required && $v.title.$dirty" class="validation-text red--text text-body-2">Title required.</span>
          <span v-if="!$v.title.maxLength" class="validation-text red--text text-body-2">Title should be 100 characters long.</span>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-textarea
            label="What's your complaint?"
            class="rounded"
            v-model.trim="$v.description.$model"
            auto-grow
            outlined
            dense
          >
          </v-textarea>
          <span v-if="!$v.description.required && $v.description.$dirty" class="validation-text red--text text-body-2">Description required.</span>
          <span v-if="!$v.description.maxLength" class="validation-text red--text text-body-2">Description should be {{$v.description.$params.maxLength.max}} characters long.</span>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-card-actions class="justify-start mx-0 px-0">
            <v-btn color="#477fca" min-width="100px" class="text-uppercase white--text" @click="postComplaint">Post</v-btn>
            <v-btn color="#ed6237" min-width="100px" class="text-uppercase white--text" @click="$emit('cancel-add')">Cancel</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="postComplete" width="500" persistent>
      <v-card>
        <v-card-title class="headline green lighten-2">
          Complaint posted successfully
        </v-card-title>

        <v-card-text style="color: #62608b">
          your complaint will be visible after admin approval
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="finishedPost"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
export default {
  data: () => ({
    title: '',
    description: '',
    postComplete: false
  }),
  validations() {
    return {
      title: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        required,
        maxLength: maxLength(20000)
      }
    }
  },
  methods: {
    ...mapActions('user', [
      'postComplaintsAndGrievances',
      'fetchComplaintsAndGrievances'
    ]),

    postComplaint() {
      let formData = new FormData()
      this.$v.title.$touch()
      this.$v.description.$touch()

      if(!this.$v.title.$invalid && !this.$v.description.$invalid && this.title && this.description) {
        formData.append('title', this.title)
        formData.append('description', this.description)
        this.postComplaintsAndGrievances(formData)
        .then(() => {
          this.fetchComplaintsAndGrievances()
          this.$emit('cancel-add')
          this.postComplete = true
        })
      }
    },

    finishedPost() {
      this.postComplete = false
      this.$router.push('/')
    }
  }
}
</script>
<style scoped>
.validation-text {
  position: relative;
  bottom: 30px;
}
</style>
